import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { ImageUpload } from "@/components/staff/ImageUpload";
import { CATEGORIES } from "@/lib/api";

const EMPTY = { name: "", price: "", category: "kopi", description: "", image: "", available: true, sort: 0, promo_start: "", promo_end: "" };

export const MenuForm = ({ open, item, onClose, onSave }) => {
  const [f, setF] = useState(EMPTY);

  useEffect(() => {
    if (open) setF(item ? { promo_start: "", promo_end: "", ...item } : EMPTY);
  }, [open, item]);

  const set = (k) => (v) => setF((p) => ({ ...p, [k]: v }));
  const submit = (e) => {
    e.preventDefault();
    const period = f.category === "paket" ? {} : { promo_start: "", promo_end: "" };
    onSave({ ...f, ...period, price: Number(f.price), sort: Number(f.sort) || 0 });
  };
  const input = "w-full px-3 py-2.5 rounded-lg border border-sage-200 bg-white/70 text-sm focus:outline-none focus:ring-2 focus:ring-forest/30";

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-paper max-w-md" data-testid="menu-form-dialog">
        <DialogHeader><DialogTitle className="font-serif text-2xl">{item ? "Ubah menu" : "Tambah menu"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <ImageUpload value={f.image} onChange={set("image")} testid="menu-form-image-input" />
          <input required value={f.name} onChange={(e) => set("name")(e.target.value)} placeholder="Nama menu" className={input} data-testid="menu-form-name-input" />
          <div className="grid grid-cols-2 gap-3">
            <input required type="number" min="0" value={f.price} onChange={(e) => set("price")(e.target.value)} placeholder="Harga (Rp)" className={input} data-testid="menu-form-price-input" />
            <Select value={f.category} onValueChange={set("category")}>
              <SelectTrigger className="bg-white/70" data-testid="menu-form-category-select"><SelectValue /></SelectTrigger>
              <SelectContent>{CATEGORIES.slice(1).map((c) => <SelectItem key={c.id} value={c.id}>{c.label}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <textarea value={f.description} onChange={(e) => set("description")(e.target.value)} placeholder="Deskripsi singkat (opsional)" rows={2} maxLength={300} className={input} data-testid="menu-form-description-input" />
          {f.category === "paket" && (
            <div data-testid="menu-form-promo-period">
              <div className="text-xs text-muted2 mb-1">Masa berlaku promo (WIB). Di luar tanggal ini paket otomatis hilang dari menu.</div>
              <div className="grid grid-cols-2 gap-3">
                <label className="text-xs">Mulai<input type="date" value={f.promo_start} onChange={(e) => set("promo_start")(e.target.value)} className={input} data-testid="menu-form-promo-start-input" /></label>
                <label className="text-xs">Selesai<input type="date" min={f.promo_start || undefined} value={f.promo_end} onChange={(e) => set("promo_end")(e.target.value)} className={input} data-testid="menu-form-promo-end-input" /></label>
              </div>
            </div>
          )}
          <div className="flex items-center justify-between">
            <label className="flex items-center gap-2 text-sm"><Switch checked={f.available} onCheckedChange={set("available")} data-testid="menu-form-available-switch" /> Tersedia</label>
            <label className="flex items-center gap-2 text-sm">Urutan <input type="number" value={f.sort} onChange={(e) => set("sort")(e.target.value)} className="w-16 px-2 py-1.5 rounded-md border border-sage-200 bg-white/70" data-testid="menu-form-sort-input" /></label>
          </div>
          <button className="btn-forest w-full py-3" data-testid="menu-form-submit-button">Simpan</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
